module.exports = __webpack_public_path__ + "img/Background_Footer.2b95e007.png";